const Renderer = require('../Renderer');
const LayerUtil = require('../../utils/LayerUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');
/**
 * 要素渲染
 * @ignore
 * @param {Object} options - 构造参数；
 * @param {G.Map} options.map - 地图对象
 * @param {String} options.id
 * @param {String} options.name
 * @param {String} options.idField
 * @param {Object} options.featureBuilder
 * @param {String} options.geometryType
 *
 * @example
 * //使用示例代码
 * //todo
 */
let renderer = Renderer.extend({
    options: {},
    initialize(options) {
        Renderer.prototype.initialize.call(this, options);
        //
        this.options.geometryType = this.options.geometryType || 'point';
        //初始化点线面图层组
        this.options.map.initialGroupLayers();
        //
        
        const symbolBuilder = this.options.featureBuilder.options.symbolBuilder;
        const layerOpts = {
            id: options.id,
            name: options.name,
            zIndex: this.options.zIndex,
            declutter:false,
        };
        if(symbolBuilder.buildStyle){
            const opts = symbolBuilder.buildStyle()||{};
            for(let key in opts){
                layerOpts[key] = opts[key];
            }
        }
        //
        this.layer = new g2.carto.ElementLayer(layerOpts);
        LayerUtil.addLayer2Group(this.options.map, this.layer, this.options.geometryType);
        
    },
    
    /**
     */
    destroy() {
        this.clear();
        LayerUtil.removeLayerFromGroup(this.options.map, this.layer, this.options.geometryType);
        Renderer.prototype.destroy.call(this);
    },
    /**
     *
     * @returns {*}
     */
    getLayer() {
        return this.layer;
    },
    /**
     *
     */
    getExtent() {
        return LayerUtil.getLayerExtent(this.layer);
    },
    /**
     *
     * @param list
     */
    add(list) {
        let len = list.length;
        // let eleList = [];
        for (let i = 0; i < len; i++) {
            let item = list[i];
            try {
                let element = this.options.featureBuilder.buildElement(item);
                // element && eleList.push(element);
                this.layer.add(element);
            }
            catch (e) {
                console.warn(e)
            }
        }
        // this.layer.addElements(eleList);
    },
    /**
     *
     * @param list
     */
    update(list) {
        let currentElements = [].concat(this.layer.elements);
        let len = list.length;
        for (let i = 0; i < len; i++) {
            let item = list[i], element;
            try {
                element = this.options.featureBuilder.buildElement(item);
            }
            catch (e) {
                console.warn(e)
            }
            let id = item[this.options.idField];
            for(let j =0, len1 = currentElements.length; j<len1 ;j++) {
                if(currentElements[j].id == id) {
                    currentElements.splice(j,1);
                    break;
                }
            }
            if(element){
                currentElements.push(element);
            }
        }
        this.layer.clear();
        this.layer.addElements(currentElements);
    },
    /***
     *
     * @param id
     */
    remove(id) {
        let existElement = this.layer.find(id);
        if (existElement) {
            this.layer.remove(existElement);
        }
        return existElement;
    },
    /**
     */
    clear() {
        this.layer.clear();
    },
    
    /**
     */
    setVisible(visible) {
        this.layer.setVisible(!!visible);
    },
    
    /**
     */
    getVisible() {
        return this.layer.visible;
    }
});

module.exports = renderer;